import { components } from '~/api'
//
// api yamlを更新したら変更しても良い

export type IQuery = {
  /** sortOrder
   *  Available values : 1, 2, 3, 4, 5, 6, 7, 8 */
  sortOrder?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
  /** ユーザーID */
  userId?: number
  /** 取得件数を指定 */
  limit?: components['parameters']['Limit']
  /** 複数取得データのオフセットを指定 */
  offset?: components['parameters']['Offset']
}

export type TContainers = {
  id: number
  // コンテナステータス（集荷率）
  cargo: string
  // 得意先名
  companyName: string
  // 顧客名
  contactPerson: string
  // コンテナタイプ
  containerSize: '20ft' | '40ft' | string
  // 国
  country: string
  // 得意先コード
  customerCode: number
  // 取引先略称
  customerNameAbbreviation: string
  // 前金
  depositPayment: boolean
  // 入力担当
  inputPersonName: string
  // 商談担当
  salesPersonName: string
  // vanning日程
  vanningDate: string
  // 請求書No
  invoiceNo: string
  // ステータス
  status: EContainerStatus
}

export enum EContainerStatus {
  BEFORE_DEPOSIT = '入金前',
  DEPOSITED = '入金済',
  SOLD = '売上済',
}

type TDepositPayment = {
  date: string
  payment: number
}

type TBlancePayment = {
  date: string
  payment: number
}

export type TContainerOrdersItem = {
  id: number
  userId: number
  containers: TContainers
}

// Response from API
export type IContainersResponse = {
  data: {
    items: TContainerOrdersItem[]
    pagination: components['schemas']['Pagination']
  }
}

export type IContainerResponse = {
  data: {
    user: {
      id: number
      name: string
    }
    // コンテナ情報
    container: {
      // コンテナNo
      id: number
      // コンテナステータス（集荷率）
      cargo: string
      // 得意先名
      companyName: string
      // 顧客名
      contactPerson: string
      // コンテナタイプ
      containerSize: string
      // 国
      country: string
      // 得意先コード
      customerCode: number
      // 取引先略称
      customerNameAbbreviation: string
      // 前金
      depositPayment: boolean
      // 入力担当
      inputPersonName: string
      // 商談担当
      salesPersonName: string
      // 入力日
      inputDate: string
      // 請求書No.
      invoiceNo: string
      // 売り上げ条件
      tradeTerms: string
      // バニング日程
      vanningDate: string
      // 船積予定日
      etd: string
      // 到着予定日
      eta: string
      // 積荷港
      portOfLoading: string
      // 陸揚げ港
      portOfDischarge: string
      // 仕向け港
      finalDestination: string
      // 荷受人
      consignees: [string]
      // 荷受人連絡先
      notifyParty: string
      // 船会社
      shippingCompany: string
      // 本船
      vessel: string
      // コンテナNo
      containerNo: string
      // 支払い期限
      paymentDue: string
      // 画像
      images: [
        {
          // ファイル名
          filename: string
          // ファイルパス
          url: string
        }
      ]
    }
    // ファイル情報
    containerFilesInfo: {
      balance: string
      packingList: {
        id: 0
        file: {
          filename: string
          url: string
        }
        name: string
        displayOrder: number
      }
      bill: {
        id: 0
        file: {
          filename: string
          url: string
        }
        name: string
        displayOrder: number
      }
      blDraft: {
        id: 0
        file: {
          filename: string
          url: string
        }
        name: string
        displayOrder: number
      }
      surrenderBl: {
        id: 0
        file: {
          filename: string
          url: string
        }
        name: string
        displayOrder: number
      }
      remark: string
      others: [
        {
          id: 0
          file: {
            filename: string
            url: string
          }
          name: string
          displayOrder: number
        }
      ]
    }
    // 商品詳細情報
    containerItems: [
      {
        id: 0
        refNo: string
        productCode: string
        productName: string
        maker: string
        carName: string
        vehicleModel: string
        engineModel: string
        transmission: string
        quantity: 0
        totalSales: string
        weight: string
        orderDate: string
        status: string
        confirmationDate: string
        remarks: string
        dismantlingCharge: string
        packingCost: string
        productionInstructionUrl: string
      }
    ]
    // 合計金額
    itemsTotalPrice: number
  }
}

export type IContainerStatusResponse = {
  // コンテナNo
  containerNo: string
  // コンテナタイプ
  containerType: string
  // コンテナステータス
  containerStatus: string
  // 個数
  itemQuantity: number
  // バニング日程
  vanningDate: string
  // ETD
  etd: string
  // ETA
  eta: string
  // 運送会社
  shippingCompany: string
  // 出発港
  portDelivery: string
  // コンテナ画像
  containerImage: string
  // pendingPrice
  pendingPrice: number
  // statementDownLoadUrl
  statementDownLoadUrl: string
  // shippingInstructionDownLoadUrl
  shippingInstructionDownLoadUrl: string
  // packingListDownLoadUrl
  packingListDownLoadUrl: string
}

export type IContainerMemo = {
  note: string
}

export type IContainerBalance = {
  balance: number
}

export type IContactOrder = {
  data: {
    items: [
      {
        id: number
        refNo: string
        name: string
        status: number
        remark: string
        maker: string
        carName: string
        modelCode: string
        engineModel: string
        year: string
        type: string
        price: string
        transmission: string
        productName: string
        date: number
        supplyType: '' | 'EXTERNAL' | 'INTERNAL'
        user: {
          companyName: string
          country: string
          email: string
          id: number
          name: string
        }
      }
    ]
    pagination: {
      currentPage: number
      limitValue: number
      totalCount: number
      totalPages: number
    }
  }
}
